<template>
  <div class="doctorDataAnalysis">
    <div class="menu_list">
      <el-menu class="menu" :default-active="activeIndex" mode="horizontal" @select="menuSelect">
        <el-menu-item index="registrationData">挂号数据</el-menu-item>
        <el-menu-item index="outpatientData">门诊数据</el-menu-item>
        <el-menu-item index="physioData">理疗数据</el-menu-item>
        <el-menu-item index="performanceData">业绩数据</el-menu-item>
        <el-menu-item v-if="teamList.length > 0" index="studioData">工作室数据</el-menu-item>
      </el-menu>
      <el-select v-if="isOperation" v-model="doctorId" filterable placeholder="请选择医生" @change="doctorChange">
        <el-option v-for="doctor in doctorOptions" :label="doctor.doctorName" :value="doctor.doctorId"></el-option>
      </el-select>
    </div>
    <div class="content">
      <components v-if="showComponent" :is="componentMap[activeIndex]" :teamList="teamList" :doctorId="doctorId"></components>
    </div>
  </div>
</template>

<script>
  import { getHeadUpTeam } from "@/api/studio.js"

  import RegistrationData from './registrationData.vue'
  import OutpatientData from './outpatientData.vue'
  import PhysioData from './physioData.vue'
  import PerformanceData from './performanceData.vue'
  import StudioData from './studioData.vue'
  export default {
    name: 'doctorDataAnalysis',
    components: {
      RegistrationData,
      OutpatientData,
      PhysioData,
      PerformanceData,
      StudioData
    },
    data () {
      return {
        showComponent: false,
        isOperation: false,
        doctorOptions: [],
        doctorId: '',
        activeIndex: "registrationData",
        componentMap: {
          'registrationData': RegistrationData,
          'outpatientData': OutpatientData,
          'physioData': PhysioData,
          'performanceData': PerformanceData,
          'studioData': StudioData
        },
        teamList: []
      }
    },
    created () {
      const userType = sessionStorage.getItem('user') && JSON.parse(sessionStorage.getItem('user')).type
      if (userType === '0') {
        this.showComponent = true
        sessionStorage.removeItem('doctorDataAnalysis_doctorId')
        this.doctorId = sessionStorage.getItem('user') && JSON.parse(sessionStorage.getItem('user')).doctorId || ''
        if (![null, undefined, ''].includes(this.doctorId)) {
          this.getTeamList()
        }
      } else {
        const roles = sessionStorage.getItem('roles') && JSON.parse(sessionStorage.getItem('roles'))
        if (roles.includes('operation-doctor')) {
          this.isOperation = true
          this.$getDoctorOptions()
          this.doctorId = (sessionStorage.getItem('doctorDataAnalysis_doctorId') && Number(sessionStorage.getItem('doctorDataAnalysis_doctorId'))) || ''

          if (![null, undefined, ''].includes(this.doctorId)) {
            this.showComponent = true
            this.getTeamList()
          }
        }
      }
    },
    methods: {
      // 切换当前显示组件
      menuSelect(key) {
        this.activeIndex = key

        try {
          const btnMap = {
            'registrationData': '挂号数据',
            'outpatientData': '门诊数据',
            'physioData': '理疗数据',
            'performanceData': '业绩数据',
            'studioData': '工作室数据'
          }
          window.$trackTool.track({ v: '1', b: 'his_000009', t: 'his_0002' }, { updateTime: new Date(window.$systemTime).Format('yyyy-MM-dd hh:mm:ss'), btnName: btnMap[key] })
        } catch (error) {}
      },
      async getTeamList () {
        const res = await getHeadUpTeam({ doctorId: this.doctorId })
        if (res.code === 200) {
          this.teamList = res.data.filter(v => { return v.status === 1 }) || []
        }
      },
      doctorChange () {
        sessionStorage.setItem('doctorDataAnalysis_doctorId', this.doctorId)
        this.showComponent = false
        this.$nextTick(() => {
          this.showComponent = true
        })
        if (![null, undefined, ''].includes(this.doctorId)) {
          this.getTeamList()
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .doctorDataAnalysis {
    width: 100%;
    height: 100%;
  }

  .menu_list {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px;
    width: 100%;
    height: 52px;
    background-color: #FFFFFF;
    border-bottom: 1px solid #E0E0E0;
  }

  .menu {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    border-bottom: none;
  }

  .menu_list /deep/.el-menu--horizontal>.el-menu-item {
    box-sizing: border-box;
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 0 0 0;
    height: 100%;
    font-weight: 500;
    font-size: 16px;
    color: #667182;
    border-bottom: none;
  }

  .menu_list /deep/.el-menu--horizontal>.el-menu-item.is-active {
    font-weight: bold;
    color: #000000;
    border-bottom: none;
  }

  .menu_list /deep/.el-menu--horizontal>.el-menu-item.is-active::after {
    content: '';
    display: block;
    position: absolute;
    z-index: 2;
    bottom: -2px;
    left: 0px;
    width: 100%;
    height: 4px;
    background-color: #1890FF;
    border-radius: 4px;
  }

  .menu_list /deep/.el-menu--horizontal>.el-menu-item + .el-menu-item {
    margin: 0 0 0 32px;
  }

  .content {
    box-sizing: border-box;
    padding: 24px;
    width: 100%;
    height: calc(100% - 52px);
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>